import * as React from 'react';
import * as classNames from 'classnames';
import Spinner from './spinner';
import ErrorMessage from './error_message';

class LoadingOverlay extends React.Component {
  static defaultProps = {
    showOverlay: false,
  };

  activeClass = () => (this.props.showOverlay ? 'loading-overlay-container--active' : '');

  spinner = () => {
    if (this.props.showOverlay) {
      return (
        <Spinner size={this.props.size} color={this.props.color} />
      );
    }
  };

  render() {
    return (
      <div className={classNames('loading-overlay-container', this.activeClass())}>
        {this.spinner()}
        <div className="loading-overlay-content">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default LoadingOverlay;



// WEBPACK FOOTER //
// ./javascripts/components/shared/loading_overlay.jsx